export enum SessionStorageKey {
    TOKEN = 'TOKEN'
}

